import React from 'react';
import { Chip, Tooltip, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import { SQUAD_LABELS, SQUAD_OPERATIONS } from '@features/Admin/Agent/constants/squad.constants';

interface SquadIndicatorProps {
  isSquad: boolean;
  isDisabled?: boolean;
  isDeleting?: boolean;
  onDelete?: () => void;
}

export const SquadIndicator: React.FC<SquadIndicatorProps> = ({
  isSquad,
  isDisabled = false,
  isDeleting = false,
  onDelete,
}) => {
  const { t } = useTranslation();

  if (isSquad) {
    return (
      <>
        <Chip color="primary" label={t(SQUAD_LABELS.SQUAD_MODE)} size="small" />
        {onDelete && (
          <Tooltip title={t(SQUAD_OPERATIONS.DELETE)}>
            <IconButton
              color="error"
              size="small"
              disabled={isDisabled || isDeleting}
              onClick={onDelete}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </>
    );
  }

  return <Chip color="default" label={t(SQUAD_LABELS.SINGLE_AGENT)} size="small" />;
};
